// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OdgT","rightAdornment":"Header_rightAdornment__43d1G"};